import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const usersRef = db.ref('users')

export const peoplesModule = {
  namespaced: true,
  state: {
    users: {},
    groups: {},
    currentGroups: {},
    userNameKeys: {},
    groupNameKeys: {},
    organizationNameKeys: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.REMOVE_FOLLOWING]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const removeFollowingRef = db.ref('users/' + currentUserId + '/following/' + value.targetType)
      removeFollowingRef.child(value.targetId).remove()
    }),
    [getterConstants.SET_VISIT_HISTORY]: firebaseAction((context, value) => {
      console.log('vicis')
      const currentUserId = context.rootState.currentUserId
      const now = new Date().getTime() / 1000
      const setVisitHistoryRef = usersRef
        .child(currentUserId)
        .child('visitHistory')
        .child(value)
      setVisitHistoryRef.set(now)
    })
  },
  getters: {
    downloadCSV: state => (target, targetName) => {
      // CSV形式のみ受け付ける
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      console.log('downloadCSV', target, targetName)
      const blob = new Blob([bom, target], {type: 'text/csv'})
      if (window.navigator.msSaveBlob) {
        // for Edge(, IE)
        window.navigator.msSaveBlob(blob, targetName + '.csv')
      } else {
        // for Chrome, Firefox, Safari
        const url = (window.URL || window.webkitURL).createObjectURL(blob)
        let link = document.createElement('a')
        link.download = targetName + '.csv'
        link.href = url
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/peoples.js